import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../../Hooks/useToggle';
import pageBanner from '../../../assets/images/backoffice-banner.webp';
import backofficeImg1 from '../../../assets/images/backoffice-dashboard.jpg';
import backofficeImg2 from '../../../assets/images/backoffice-invoices.jpg';
import BackToTop from '../../BackToTop';
import FooterHomeThree from '../../Footer/FooterHomeThree';
import HeaderNews from '../../Header/HeaderNews';
import HeroNews from '../../Header/HeroNews';
import Drawer from '../../Mobile/Drawer';
import PreviewSlider from '../../PreviewSlider';
import ServicesAbout from './ServicesAbout';
import ShowCase from './ShowCase';

function Backoffice() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Optimize your financial processes with OTO's smart financing software in Kigali, Rwanda. Our Backoffice app offers automated invoicing, cash flow management, financial reporting, and more to streamline your financial operations. Contact us for a demo!"
                />
                <title>Smart Financing Solutions by OTO Backoffice - Kigali, Rwanda</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <HeroNews
                title="Backoffice"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/apps', title: 'Apps' },
                    { link: '/apps/frontdesk', title: 'Frontdesk' },
                ]}
            />

            <div className="container pt-90 pb-90" style={{ fontSize: '18px', lineHeight: '29px' }}>
                <h3 className="mb-4">Backoffice Software</h3>
                <p className="mb-3">
                    Are you tired of managing your business's invoices, cash books and other
                    financial operations manually, spending countless hours on paperwork and data
                    entry? Our backoffice software can help simplify and streamline your business
                    operations, allowing you to focus on growing your business.
                </p>
                <p>
                    Our backoffice app can help you manage invoices, proforma, cash books and much
                    more.
                </p>

                <img
                    className="page-banner-img mt-4"
                    src={pageBanner}
                    alt="OTO Inventory Software"
                />
            </div>

            <ServicesAbout />

            <ShowCase />

            <div className="container">
                <PreviewSlider
                    images={[
                        { url: backofficeImg1, alt: 'Backoffice' },
                        { url: backofficeImg2, alt: 'Backoffice' },
                    ]}
                />
            </div>
            <div className="container pt-60 pb-80 text-center">
                <div className="mx-auto" style={{ maxWidth: '800px' }}>
                    <p className="mb-3">
                        Don't waste another minute on manual data entry and accounting. Contact us
                        today to learn more about how our backoffice software can help streamline
                        your financial operations and drive growth.
                    </p>
                </div>
            </div>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Backoffice;
